import { type StatusData } from '../Layers/Layers.types';
import { TrafikenConfig } from '../TrafikenConfig';
import { AjaxSource } from './AjaxSource';
import type { AjaxSourceOptions } from './Sources.types';

const defaultOptions = (region) => ({
    id: 'travel-time-v2-status-source',
    url: `${TrafikenConfig.infoLayerServiceBaseUrl}/api/v2/traveltime?region=${region}`,
    displayName: 'Trafikflöde',
});

export interface TravelTimeV2Status extends StatusData {
    status?: string;
    speed?: number;
    updateDate?: string;
}

/**
 * Status source backed by the TomTom-fed /api/v2/traveltime endpoint.
 * Carries per-segment status keyed by the TomTom segment id; geometry is joined
 * client-side from TravelTimeV2SectionSource by the same id. The updateDate is
 * supplied by the backend (the segment's HTTP completion time, or the response
 * time on a cache-miss fallback).
 */
export class TravelTimeV2StatusSource extends AjaxSource {
    constructor(region: string, options?: Partial<AjaxSourceOptions>) {
        super({ ...defaultOptions(region), ...options });
    }
}
